<template>
  <div class="card-page-container mdl-shadow--2dp">
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">Send free SMS</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--4-col">
            <div class="profile-label">To country code (IT, US, ...)</div>
          </div>
          <div class="mdl-cell mdl-cell--8-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="text" id="toCountryCode" v-model="toCountryCode">
            </div>
          </div>

          <div class="mdl-cell mdl-cell--4-col">
            <div class="profile-label">To destination number (+39...)</div>
          </div>
          <div class="mdl-cell mdl-cell--8-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="text" id="toDestination" v-model="toDestination">
            </div>
          </div>

          <div class="mdl-cell mdl-cell--4-col">
            <div class="profile-label">Free text</div>
          </div>
          <div class="mdl-cell mdl-cell--8-col">
            <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
              <input class="mdl-textfield__input" type="text" id="text" v-model="text">
            </div>
          </div>
          <div class="mdl-card__actions">
            <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored float-right"
                v-on:click="submit()">
              Send
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var api = require('api')
module.exports = {
  ready: function () {
  },
  methods: {
    submit: function (lang) {
      api.SendSMS.send({
        prefix: this.toCountryCode,
        dst: this.toDestination,
        text: this.text
      })
      .then(this.onSuccess)
      .catch(this.onError)
    },
    onSuccess: function () {
      this.$dispatch('show-success', 'Free SMS sent')
      this.toCountryCode = 'IT'
      this.toDestination = '+39'
      this.text = ''
    },
    onError: function (err) {
      this.$dispatch('show-error', err)
    }
  },
  data: function () {
    return {
      toCountryCode: 'IT',
      toDestination: '+39',
      text: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// SendSMS.vue?9388fe0a